import { render, staticRenderFns } from "./add-doctor.vue?vue&type=template&id=57f23d33&"
import script from "./add-doctor.vue?vue&type=script&lang=js&"
export * from "./add-doctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports